module.exports = __webpack_public_path__ + "static/media/icon-assign-now.afc5b7fb.svg";